import React, { Fragment, useState } from 'react';
import styled from '@emotion/styled';

const Label = styled.label`
font-family: 'Bebas Neue', cursive;
font-weight: bold;
font-size: 2.4rem;
color: #fff;
text-transform: uppercase;
margin-top: 2rem;
display: block;
`;
const Select = styled.select`
width:100%;
display: block;
padding: 1rem;
-webkit-appearance:none;
border-radius:10px;
border:none;
font-size:1.2rem;
`;

const useCurrency = (label, stateInicial, CURRENCY) => {
    const [state, setCurrency] = useState(stateInicial);
    const SelectCurrency = () => (
      <Fragment>
            <Label>{label}</Label>
            <Select
                onChange={e => setCurrency(e.target.value)}
                value={state}
            >
                <option value="MXN">--Seleccione--</option>
                {CURRENCY.map(option => (
                    <option key={option.code} value={option.code}>{option.name}</option>
                ))}
        </Select>
      </Fragment>
    );
    return [state, SelectCurrency, setCurrency];
}

export default useCurrency;